// src/pages/NotFound404.jsx
import { Box, Button, Image, Text, VStack, HStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import scissor from "../assets/loadinganderror/scissor.png"; 

const NotFound404 = () => {
  const navigate = useNavigate();

  return (
    <Box
      bg="#FFE2AF"
      h="100vh"
      w="100vw"
      display="flex"
      justifyContent="center"
      alignItems="center"
      px={4}
    >
      <VStack spacing={2}>
        {/* 4✂4 */}
        <HStack spacing={0}>
          <Text fontSize={["5xl", "6xl", "7xl"]} color="#E76F51" fontWeight="bold">
            4
          </Text>
          <Image
            src={scissor}
            alt="Scissor"
            height={["40px", "60px", "70px"]}
            width="auto"
            objectFit="contain"
          />
          <Text fontSize={["5xl", "6xl", "7xl"]} color="#E76F51" fontWeight="bold">
            4
          </Text>
        </HStack>

        {/* Message */}
        <Text fontSize={["md", "lg", "xl"]} color="black" fontWeight="medium">
          PAGE NOT FOUND :(
        </Text>

        {/* Button */}
        <Button
          bg="#002E2C"
          color="white"
          _hover={{ bg: "#014442" }}
          onClick={() => navigate("/")}
        >
          Back to Home
        </Button>
      </VStack>
    </Box>
  );
};

export default NotFound404;
